import { useNavigate } from 'react-router-dom'
import { styled } from '../../../lib/stitches'
import Button from '../../core/Button/Button'
import Text from '../../core/Text/Text'

const segmentMarketingPage = (button: string) => {
  window.analytics.track('Button Clicked', {
    button: button,
    location: 'marketing page',
    source: window.location.pathname
  })
}

const FreeInBrowserWrapper = styled('div', {
  width: '100%',
  backgroundImage: 'url(/static/images/gradient-free.png)',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundColor: '$white',
  '@tablet': {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  }
})

const FreeInBrowserContent = styled('div', {
  padding: '20px 24px 72px',
  maxWidth: '768px',
  margin: '0 auto',
  '@tablet': {
    padding: '0 0 156px'
  }
})

const ButtonWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  margin: '32px 0 64px',
  '@tablet': {
    margin: '30px 0 112px'
  }
})

const FreeInBrowser = () => {
  const navigate = useNavigate()

  return (
    <FreeInBrowserWrapper>
      <FreeInBrowserContent>
        <Text
          css={{
            fontSize: '32px',
            fontWeight: '700',
            letterSpacing: '-1px',
            lineHeight: '36px',
            color: '$gray15',
            textAlign: 'center',
            '@tablet': {
              fontSize: '40px',
              lineHeight: '50px',
              letterSpacing: '-2px',
              color: '$gray14'
            }
          }}
        >
          Free in-browser DAW powered by Web3
        </Text>
        <Text
          css={{
            fontSize: '17px',
            fontWeight: '400',
            letterSpacing: '-0.04em',
            lineHeight: '28px',
            color: '$gray11',
            opacity: '0.6',
            textAlign: 'center',
            margin: '16px 0 32px',
            '@tablet': {
              fontSize: '18px',
              lineHeight: '32px'
            }
          }}
        >
          Arpeggi Studio is a platform for musicians to publish their sounds for others to create
          with. Using our in-browser DAW, anyone can create music and mint it as an NFT, completely
          free.
        </Text>
        <ButtonWrapper
          css={{
            margin: 0,
            '@tablet': {
              margin: 0
            }
          }}
        >
          <Button
            type="dark"
            onClick={() => {
              segmentMarketingPage('Sign up for demo')
              window.open('https://calendly.com/arpeggi-demo/arpeggi-demo', '_blank')
            }}
            css={{
              height: '40px',
              padding: '0 16px',
              fontWeight: 500,
              fontSize: '16px',
              borderRadius: '10px',
              '@tablet': {
                marginRight: '8px',
                height: '48px',
                color: '$gray15',
                backgroundColor: '$gray01',
                border: '1px solid $button__border'
              }
            }}
          >
            Sign up for demo
          </Button>
          <Button
            type="dark"
            onClick={() => {
              segmentMarketingPage('Try now')
              navigate('/studio')
            }}
            css={{
              display: 'none',
              '@tablet': {
                display: 'block',
                fontWeight: 500,
                padding: '0 50px',
                height: '48px',
                fontSize: '16px',
                borderRadius: '10px',
                color: '$gray01'
              }
            }}
          >
            Try now
          </Button>
        </ButtonWrapper>
      </FreeInBrowserContent>
    </FreeInBrowserWrapper>
  )
}

export default FreeInBrowser
